import styled, { css } from 'styled-components';
import { Link } from 'gatsby';
import { baseFontSize } from './font';

export const highlightStyle = css`
  color: white;
  text-shadow: 0 1px 0 ${({ theme }): string => theme.commons.colors.primary};

  &:after {
    height: calc(100% - 4px);
    width: calc(100% + 16px);
    bottom: 2px;
    background-color: ${({ theme }): string => theme.commons.colors.primary};
    border-radius: 4px;
  }
`;

export const formatLinkStyle = css`
  display: inline-block;
  ${({ theme }): string => theme.mixins.margin({ top: 0, right: 1, bottom: 0, left: 0 })};
  text-decoration: none;
  position: relative;
  cursor: pointer;
  z-index: 0;
  text-shadow: 0 1px 0 white;
  color: ${({ theme }): string => theme.commons.colors.primary};
  transition:
    color 250ms,
    text-shadow 250ms;
  ${baseFontSize};
  line-height: ${({ theme }): string => theme.mixins.spacing(3.5)};
  font-weight: 500;
`;

const linkStyle = css`
  ${formatLinkStyle}

  &:after {
    position: absolute;
    z-index: -1;
    bottom: 2px;
    left: 50%;
    transform: translateX(-50%);
    content: ' ';
    width: 100%;
    height: 0;
    background-color: ${({ theme }): string => theme.commons.colors.primary};
    transition: all 250ms;
  }

  &:hover {
    ${highlightStyle}
  }
`;

export const ExternalLinkHighlight = styled.a`
  ${linkStyle}
`;

export const InternalLinkHighlight = styled(Link)`
  ${linkStyle}
`;
